var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/createTrailingBlockPlugin.ts
import {
  createPluginFactory,
  ELEMENT_DEFAULT as ELEMENT_DEFAULT2,
  getPluginType as getPluginType2
} from "@udecode/plate-common";

// src/withTrailingBlock.ts
import {
  ELEMENT_DEFAULT,
  getLastNodeByLevel,
  getPluginType,
  insertElements,
  queryNode
} from "@udecode/plate-common";
import { Path } from "slate";
var withTrailingBlock = (editor, _a) => {
  var {
    options: _b
  } = _a, _c = _b, { type = getPluginType(editor, ELEMENT_DEFAULT), level } = _c, query = __objRest(_c, ["type", "level"]);
  const { normalizeNode } = editor;
  editor.normalizeNode = ([currentNode, currentPath]) => {
    if (currentPath.length === 0) {
      const lastChild = getLastNodeByLevel(editor, level);
      const lastChildNode = lastChild == null ? void 0 : lastChild[0];
      if (!lastChildNode || lastChildNode.type !== type && queryNode(lastChild, query)) {
        const at = lastChild ? Path.next(lastChild[1]) : [0];
        insertElements(editor, editor.blockFactory({}, at), { at });
        return;
      }
    }
    return normalizeNode([currentNode, currentPath]);
  };
  return editor;
};

// src/createTrailingBlockPlugin.ts
var KEY_TRAILING_BLOCK = "trailingBlock";
var createTrailingBlockPlugin = createPluginFactory({
  key: KEY_TRAILING_BLOCK,
  withOverrides: withTrailingBlock,
  options: {
    level: 0
  },
  then: (editor) => ({
    type: getPluginType2(editor, ELEMENT_DEFAULT2)
  })
});
export {
  KEY_TRAILING_BLOCK,
  createTrailingBlockPlugin,
  withTrailingBlock
};
//# sourceMappingURL=index.mjs.map